import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],


})
export class LoadingComponent implements OnInit {
  @Input() public ativo: boolean;
  @ViewChild('element') public element: ElementRef;
  @Input() public text: string;
  public isActive: boolean = false;
  

  public ngOnInit() {

  }

  ngOnChanges(){
    this.ativo = this.ativo == undefined ? false : this.ativo;
    this.isActive = this.ativo
  }


}
